const ZNS_API_BASE = 'https://zns.bio/api';
const INK_CHAIN_ID = 57073;

interface ZNSResolveResponse {
  code: number;
  address?: string;
}

/**
 * Resolve a ZNS .ink domain name to an Ethereum address
 * @param name - Domain name (e.g., "mavrk.ink" or "mavrk")
 * @returns Ethereum address or null if not found
 */
export async function resolveZNSName(name: string): Promise<string | null> {
  try {
    // Normalize to lowercase (ZNS domains are case-insensitive)
    const normalizedName = name.toLowerCase();
    
    // Ensure .ink suffix is removed for API (API expects just the name without .ink)
    const nameOnly = normalizedName.endsWith('.ink') ? normalizedName.replace('.ink', '') : normalizedName;
    
    const url = `${ZNS_API_BASE}/resolveDomain?chain=${INK_CHAIN_ID}&domain=${nameOnly}`;
    console.log('[ZNS] Resolving domain to address:', nameOnly);
    
    const response = await fetch(url);
    
    if (!response.ok) {
      console.error('[ZNS] API error:', response.status);
      return null;
    }

    const data: ZNSResolveResponse = await response.json();
    
    if (data.code === 200 && data.address) {
      console.log('[ZNS] Resolved to address:', data.address);
      return data.address;
    }
    
    console.log('[ZNS] Domain not found:', nameOnly);
    return null;
  } catch (err) {
    console.error('[ZNS] Error resolving domain:', err);
    return null;
  }
}

/**
 * Validate if a string is a valid Ethereum address
 */
export function isValidAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}

/**
 * Validate if a string is a valid .ink domain
 */
export function isValidInkDomain(name: string): boolean {
  return /^[a-z0-9-]+\.ink$/.test(name.toLowerCase());
}

